import { useContext, useMemo } from "react";
import { GeaoContext } from "../GeaoContextProvider";
import { getAnswer } from "../mappers/InterviewMapper";
import { GeaoPaths } from "../constants/GeaoPaths";

export default function useDisabledPages() {
    const { agencyInterview } = useContext(GeaoContext);

    const disabledPages = useMemo(() => {
        const isAffiliatedWithTop100 = getAnswer(agencyInterview, "AffiliatedWithTop100");
        const isFirmNetworkAggregatorCommissionPayments = getAnswer(agencyInterview, "FirmNetworkAggregatorCommissionPayments");
        const isAgencyCommissionPayments = getAnswer(agencyInterview, "AgencyCommissionPayments");

        const agencyIsNotPaidDirectly =
            (isAffiliatedWithTop100 === "true" && isFirmNetworkAggregatorCommissionPayments === "true") ||
            isAgencyCommissionPayments === "false";

        if (agencyIsNotPaidDirectly) {
            return [
                GeaoPaths.PrincipalBankingInformation,
                GeaoPaths.PrincipalW9TaxForm
            ];
        }

        return [];
    }, [agencyInterview]);

    return disabledPages;
}